import React, { Component } from 'react';

import { LOCAL_STORAGE_VAR } from '../../../constants/Common';
import DiamondListingAction from '../../common/DiamondListing/DiamondListingAction';
import SimilarStone from '../SimilarStone';

class MobileDiamondDetail extends Component {
  render() {
    const data = this.props.data;
    const parent = this.props.parent;

    return (
      <>
        <div className="mobilediamondDetail">
          <div className="mobilediamond diamondDetailLeft">{parent.leftPart()}</div>
          <div className="diamondDetailRight mobileRightDetail">{this.props.params}</div>
          <div className="similarStoneBlock">
            <div className="similarStoneInner">
              <h2 className="detailSmallTitle">Similar Stone</h2>
              {data.id && <SimilarStone id={data.id} />}
            </div>
          </div>
          {parent.getEmailModal()}
        </div>
        {localStorage.getItem(`${LOCAL_STORAGE_VAR}-token`) ? (
          <DiamondListingAction
            nofinalcalc
            nonote
            nooffice
            order
            noreminder
            noExportExcel
            noprint
            nopaginate
            checkedData={[data] || []} // <-
            data={[data] || []} // <-
          />
        ) : (
          <div className="mobileSearchBottom">
            <div className="mobileSearchActionItem">
              <a href="/signin">
                <span>Sign In</span>
              </a>
            </div>
            <div className="mobileSearchActionItem">
              <a href="/signup">
                <span>Register</span>
              </a>
            </div>
          </div>
        )}
      </>
    );
  }
}

export default MobileDiamondDetail;
